// ** MUI Imports
import { Theme } from '@mui/material/styles'

const select = (theme: Theme) => {
  return {
    MuiSelect: {
      styleOverrides: {
        select: {
          minWidth: '6rem !important',
          '&.MuiTablePagination-select': {
            minWidth: '1.5rem !important'
          },
          '&.Mui-disabled ~ .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.customColors.main.replace(')', ', 0.22)')
          }
        }
      }
    }
  }
}

export default select
